module.exports = "/_next/static/images/search_bg_15-fb64eb4204f2dd4a39f8dd7d76e71c4f.jpg";